export const volunteerWorks = [
  {
    company: "BGOO Team",
    title: "Back-end developer",
    jobDescription:
      "I was actively involved in the back-end development of an application that aims to provide freelance jobs to people with psychological problems.",
    startDate: "09/2022",
    endDate: "10/2022",
  },
];
